import { render, staticRenderFns } from "./userFeedBackList.vue?vue&type=template&id=e26c8228&"
import script from "./userFeedBackList.vue?vue&type=script&lang=js&"
export * from "./userFeedBackList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports